export const Constants = {
  HEADER_TEXT: 'Morningstar Style Box™',
  DATA_AS_OF: 'Data as of',
} as const;
